import { FILTER_KEYS } from "/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/tasks.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/tasks.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindAllTasksQueryOptions, getFindTaskAssignablePersonsQueryOptions, getFindTaskAssignableTeamsQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
const tasksSearchSchema = createTableQuerySchema({
  filterKeys: FILTER_KEYS
});
export const Route = createFileRoute('/_rootLayout/tasks')({
  validateSearch: search => tasksSearchSchema.parse(search),
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'TASKS',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    const search = tasksSearchSchema.parse(location.search);
    queryClient.ensureQueryData(getFindAllTasksQueryOptions(search));
    queryClient.ensureQueryData(getFindTaskAssignablePersonsQueryOptions());
    queryClient.ensureQueryData(getFindTaskAssignableTeamsQueryOptions());
    return {
      crumb: t('NAVIGATION.TASKS'),
      to: '/tasks'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});